import { Editor } from "@tinymce/tinymce-react";
import { useEffect, useRef, useState } from "react";
import { getParamsValue } from "../../Utilities/helperFunction";

function RichTextComponent({
  setScrollDisable,
  name,
  maintainValues,
  setMaintainValues,
  setValue,
}) {
  const editorRef = useRef(null);

  useEffect(() => {
    if (!maintainValues[name]) {
      const inputVal = getParamsValue(name);
      setValue(name, inputVal);
      setMaintainValues({ ...maintainValues, [`${name}`]: inputVal });
    }
  }, []);

  const handleChange = (e) => {
    setValue(name, e);
    setMaintainValues({ ...maintainValues, [`${name}`]: e });
  };
  return (
    <>
      <div
        className="richtext-container"
        onMouseEnter={() => setScrollDisable(true)}
        onMouseLeave={() => setScrollDisable(false)}
      >
        <Editor
          apiKey="no-api-key"
          onInit={(_, editor) => (editorRef.current = editor)}
          value={maintainValues[name]}
          onEditorChange={handleChange}
          init={{
            height: 300,
            menubar: false,
            branding: false,
            placeholder: "Type here...",
            plugins: [
              "lists",
              "link",
              "autolink",
              "code",
              "table",
              "image",
              "media",
              "anchor",
              "directionality",
            ],

            toolbar:
              "undo redo | bold italic underline | bullist numlist | link | alignleft aligncenter alignright | code",

            content_style:
              "body { font-family: Arial, sans-serif; font-size: 14px; margin: 10px; }",
          }}
        />
      </div>
    </>
  );
}

export default RichTextComponent;
